<!-- src/views/UsersView.vue -->
<script setup>
import {ref, onMounted} from "vue";
import { useRoute } from "vue-router";
import { POPEntity } from "@/entities/POPEntity.js";
import BasePage from "@/components/Layouts/BasePage.vue";
import EntityForm from "@/components/common/Form.vue";
import { useI18n } from "vue-i18n";
import {createPOP, getPOPById, savePop} from "@/services/api/POP.js";
import ButtonSave from "@/components/common/button/ButtonSave.vue";
import { handleError } from '@/utils/errors';
import router from "@/router/index.js";
import {buildPayloadFromEntity, populateFormFromEntity} from "@/utils/index.js";

const { t } = useI18n();
const route = useRoute();
const entity = new POPEntity();
const formData = ref(entity.getDefaultValues());
const loading = ref(false);
const id = route.params.id;
const isMounted = ref(false);
const form = ref(null);

async function onSave() {
    try {
        const { valid } = await form.value.form.validate();
        if (!valid) return;


        loading.value = true;

        formData.value.country = "Brasil";
        formData.value.id = id ?? null;
        const payload = buildPayloadFromEntity(entity, formData.value);
        payload.id = formData.value.id ?? null;

        await savePop(payload);

        await router.push("/isp/pops");
        message.success(t("common.messages.success.save"));
    } catch (error) {
        console.error(error);
        message.error(await handleError(error, t, formData?.value?.name));
    } finally {
        loading.value = false;
    }
}


async function onFieldChange({ field, value }) {
    if (field.endpoint === "viacep" && value) {
        const cep = value.replace(/\D/g, '');
        if (cep.length === 8) {
            try {
                const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                const data = await res.json();

                if (!data.erro) {
                    const map = {
                        localidade: "city",
                        bairro: "neighborhood",
                        logradouro: "address_line1",
                        uf: "state"
                    };

                    Object.keys(map).forEach(apiKey => {
                        if (formData.value.hasOwnProperty(map[apiKey])) {
                            formData.value[map[apiKey]] = data[apiKey];
                        }
                    });

                    if (formData.value.hasOwnProperty("country")) {
                        formData.value.country = "Brasil";
                    } else {
                        formData.value.country = "Brasil";
                    }
                }
            } catch (e) {
                console.error("Erro ao buscar CEP:", e);
            }
        }
    }
}


onMounted(async () => {
    try {
        if (id) {
            isMounted.value = false;
            const response = await getPOPById({ id });

            formData.value = populateFormFromEntity(entity, response.data);
        }
    } catch (e) {
        console.error(e);
    } finally {
        isMounted.value = true;
    }
});

</script>

<template >
    <BasePage :loading-mounted="isMounted" :entity="entity">
        <template #default>
            <EntityForm :entity="entity" v-model="formData"  ref="form" @field-change="onFieldChange" />
            <ButtonSave :loading="loading"  @click="onSave" />
        </template>
    </BasePage>
</template>

